import React from 'react';
import styles from './Header.module.scss';
import cn from 'classnames';

const Header = ({
  heading,
  description,
  icon,
  actions,
  disabled = false,
  onClick,
  activeCount,
}) => {
  return (
    <div
      className={cn(styles.header, {
        [styles.clickable]: !!onClick,
      })}
      onClick={onClick}
    >
      <div className={styles.containerTitleRow}>
        <div className={styles.titleRow}>
          {icon && <div className={styles.icon}>{icon}</div>}

          <div
            className={cn(styles.heading, {
              [styles.disabledText]: disabled,
            })}
          >
            {heading}
          </div>
        </div>

        {(activeCount || actions) && (
          <div className={styles.blockActive}>
            {activeCount > 0 && (
              <span className={styles.activeCount}>Активно: {activeCount}</span>
            )}
            {actions && actions}
          </div>
        )}
      </div>

      {description && <div className={styles.description}>{description}</div>}
    </div>
  );
};

export default Header;
